const STORAGE_KEY = "hub.adminStandardUserPreview";
export const STANDARD_USER_PREVIEW_HEADER = "x-hub-preview-standard-user";

export function standardUserPreviewActive(): boolean {
  return typeof window !== "undefined" && window.sessionStorage.getItem(STORAGE_KEY) === "1";
}

export function standardUserPreviewRequestHeader(): Record<string, string> {
  return standardUserPreviewActive() ? { [STANDARD_USER_PREVIEW_HEADER]: "1" } : {};
}

export function setStandardUserPreview(active: boolean): void {
  if (active) window.sessionStorage.setItem(STORAGE_KEY, "1");
  else window.sessionStorage.removeItem(STORAGE_KEY);
  window.location.reload();
}
